<template>
    <div>
        <building
            :question="question"
            v-model="buildingList"
            :read-only="readOnly"
            :visit="visit"
        ></building>
        <div style="height: 1px; background: #ddd; margin: 15px 0px"></div>
        <construction
            :question="question"
            v-model="buildingList"
            :read-only="readOnly"
        ></construction>
        <div style="height: 1px; background: #ddd; margin: 15px 0px"></div>
        <occupancyhazard
            :question="question"
            v-model="buildingList"
            :read-only="readOnly"
        ></occupancyhazard>
    </div>
</template>
<script>
import Collection from '@/lib/data/Collection';
import BuildingRSA from '@/data/BuildingRSA';
import FormQuestion from '@/data/FormQuestion';
import eventBus from '@app/src/lib/helpers/eventbus';
import building from './building.vue';
import construction from './construction.vue';
import occupancyhazard from './occupancyhazard.vue';

export default {
    components: { building, construction, occupancyhazard },
    props: {
        question: {
            type: FormQuestion,
            default: new FormQuestion(),
        },
        readOnly: {
            type: Boolean,
            default: false,
        },
        visit: null,
    },
    data() {
        return {
            buildingList: new Collection({
                model: BuildingRSA,
            }),
        };
    },
    created() {
        this.parse();
    },
    mounted() {
        eventBus.$on('saveForm', this.saveForm);
        eventBus.$on('formdetailloaded', this.parse);
    },
    beforeDestroy() {
        eventBus.$off('saveForm', this.saveForm);
        eventBus.$off('formdetailloaded', this.parse);
    },
    computed: {
        returnValue: {
            get() {
                return this.question.data.return_value;
            },
            set(value) {
                this.question.data.return_value = value;
            },
        },
    },
    methods: {
        parse() {
            const returnValueJson = JSON.parse(this.returnValue || '{}');
            const list = returnValueJson.building_list;

            if (list) {
                this.buildingList.length = 0;
                this.buildingList.loadData(list);
            }
        },
        saveForm() {
            const returnValueJson = JSON.parse(this.returnValue || '{}');
            returnValueJson.building_list = this.buildingList.getData(true);
            this.returnValue = JSON.stringify(returnValueJson);
        },
    },
};
</script>
